'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$() {
}
export { $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$ as $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$ as $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$ };
$h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return 67066748;
});
$p.b = (function() {
  return "Email";
});
$p.n = (function() {
  return 0;
});
$p.o = (function() {
  return "Email";
});
$p.g = (function(n) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.y = (function(p) {
  return this;
});
var $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$, "be.doeraene.webcomponents.ui5.configkeys.InputType$Email$", ({
  gv: 1,
  b0: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$ as $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$ };
var $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$;
function $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$)) {
    $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$ = new $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$ as $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Email$ };
